module.exports = __webpack_public_path__ + "logo_200.png?f61678d0be9c32829d063a921d94e7ec";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_200.png
// module id = 211
// module chunks = 0